import { useState, useEffect, useRef } from "react";
import "./Chatbot.css";
import axios from "axios";

const YOU = "you";
const AI = "ai";

const fetchVoices = (inputText) => {
  const availableVoices = speechSynthesis.getVoices();

  const ziraVoice = availableVoices.find(
    (voice) => voice.name === "Google हिन्दी"
  );

  const utterance = new SpeechSynthesisUtterance(inputText);
  utterance.voice = ziraVoice;
  utterance.rate = 1.2; // Speech rate (0.1 to 10)
  utterance.pitch = 1; // Speech pitch (0 to 2)

  return speechSynthesis.speak(utterance);
};

function Chatbot() {
  const [qna, setQna] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");

  const chatContainerRef = useRef(null);

  const handleChange = (event) => {
    setQuery(event.target.value);
  };

  const updateQNA = (from, value) => {
    setQna((qna) => [...qna, { from, value }]);
  };

  var transcript = "";

  const handleVoiceSearch = () => {
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.start();

    recognition.onresult = (event) => {
      transcript = event.results[0][0].transcript;
      setQuery(transcript);
    };

    recognition.onend = () => {
      console.log("Speech recognition ended");
    };
  };

  const handleSend = () => {
    if (query === null || query === "") {
      alert("Don't let my box empty!");
      return;
    }

    updateQNA(YOU, query);

    setLoading(true);
    axios
      .post("https://shremish-backend11.onrender.com/chat", {
        query: query || transcript,
      })
      .then((response) => {
        updateQNA(AI, response.data.answer);
        fetchVoices(response.data.answer);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderContent = (qna) => {
    const value = qna.value;

    if (Array.isArray(value)) {
      return value.map((v) => {
        return (
          <p key={v} className="message-text">
            {v}
          </p>
        );
      });
    }

    return <p className="message-text">{value}</p>;
  };

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [qna]);

  useEffect(()=>{
    fetchVoices("Welcome! I'm Shremish, your virtual assistant. How can I assist you?")
  },[])

  return (
    <>
      <main className="container">
        <div className="chats" ref={chatContainerRef}>
          <h1 style={{ textAlign: "center", color: "blue" }}>Shremish</h1>

          <div className="chat-heading-desc">
            <p style={{ textAlign: "center" }}>
              You can create a list of common questions related to your business
              or organization and provide answers to them through the chatbot.
              This will help users quickly get the information they need without
              having to go through multiple pages or contact support.
            </p>
          </div>
          <div
            style={{
              border: "1px solid rgb(219, 219, 219)",
              marginTop: "2rem",
              marginBottom: "2rem",
            }}
          ></div>
          {qna.map((qna) => {
            if (qna.from === YOU) {
              return (
                <div className="send chat">
                  <i
                    className="far fa-user avtar"
                    style={{
                      fontSize: "1.3rem",
                      marginLeft: "1rem",
                      marginRight: "2rem",
                    }}
                  ></i>
                  <p style={{ fontSize: ".9rem", fontWeight: "500" }}>
                    {renderContent(qna)}
                  </p>
                </div>
              );
            }
            return (
              <div className="recieve chat">
                <p
                  style={{
                    fontSize: ".9rem",
                    fontWeight: "500",
                    paddingLeft: ".8rem",
                  }}
                >
                  {renderContent(qna)}
                </p>
              </div>
            );
          })}

          {loading && (
            <div className="recieve chat">
              <p style={{ paddingLeft: "2rem" }}>Typing...</p>
            </div>
          )}
        </div>

        <div className="chat-input">
          <input
            type="text"
            onChange={handleChange}
            className="form-control col"
            placeholder="Type Something"
            value={query || transcript}
          />
          <i
            className="fas fa-paper-plane"
            onClick={handleSend}
            style={{
              fontSize: "1.3rem",
              alignContent: "center",
              display: "grid",
              marginLeft: "-2.5rem",
              cursor: "pointer",
              color: "blue",
            }}
          ></i>
          <i
            className="fa-solid fa-microphone"
            onClick={handleVoiceSearch}
            style={{
              fontSize: "1.3rem",
              alignContent: "center",
              display: "grid",
              marginLeft: "-3.5rem",
              cursor: "pointer",
              color: "blue",
            }}
          ></i>
        </div>
      </main>
    </>
  );
}

export default Chatbot;
